import axios from "axios";

class SearchApi {

  search(keyword:string, month?:number): Promise<any[]> {
    const apiUrl = `/api/v1/series?keyword=${keyword}${month && `&month=${month}`}&type=series`;

    return axios.get(apiUrl)
    .then(response => {
      return Promise.resolve(response.data);
    });
  }

}

export default SearchApi;